export default {
	data(){
		return {
			tableGBoptions: { 
				options: {editar: 'Editar Proveedor de Lentes', inactivar: 'Inactivar Proveedor de Lentes'},
				modals: []
			},

			tableGBSearch: ['datos_proveedores_lente/name'],
			
			tableGBItems: [
				{
					thead: { th: 'Nit', sort: null, sortTable: 'datos_lentes/documento'},
					tbody: { td: ['datos_proveedores_lente/documento']}
				},
				{
					thead: { th: 'Proveedor', sort: null, sortTable: 'datos_proveedores_lente/name'},
					tbody: { td: ['datos_proveedores_lente/name'],}
				},
				{
					thead: { th: 'Telefonos', },
					tbody: { td: ['datos_proveedores_lente/telefonos'],}
				},
				{
					thead: { th: 'Direccion', },
					tbody: { td: ['datos_proveedores_lente/direccion'],}
				},
				{
					thead: { th: 'Email', },
					tbody: { td: ['datos_proveedores_lente/email'],}
				},
			]			
		}
	},
}